export const titles = {
  home: 'ホーム',
  information: 'お知らせ',
  eLearning: 'e講義',
  grade: '成績',
  myPage: 'マイページ',
}
